import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import Color from '@tool/color';
import moIndex from '../../../store/index';
import { newValue, newRate } from '@tool/index';

const moSalaryIndustry = observable({
  xData: <any[]>[],
  yData: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  tableHead: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  pageNum: 0,
});

const initSalaryIndustry = action((res: any) => {
  // console.log('行业涨薪率 -- ', res);
  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const tableLeft: any[] = [];
  const tableRight: any[] = [];
  const years: any[] = [];
  const series: any[] = [];
  const overview: any[] = [];
  let pageNum = 0;

  res.data?.map((item: any) => {
    xData.push(item.industry);
    series.push(item.year_data);
    tableLeft.push(item.industry);
  });

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });
  // console.log('overview -- ', overview);

  series.map((item: any) => {
    item?.map((child: any) => {
      years.push(child.date);
    });
  });
  uniq(years).map((year: any) => {
    const temp: any[] = [];
    series.map((item: any) => {
      item?.map((child: any) => {
        if (child.date === year) temp.push(child.change_rate);
      });
    });
    yData.push({
      name: year,
      data: temp,
    });
  });
  // console.log('yData -- ', yData);

  // tableRight.push(uniq(years));
  res.data?.map((item: any) => {
    const temp: any[] = [];
    item.year_data?.map((child: any) => {
      temp.push(child.change_rate);
    });
    tableRight.push(temp);
  });
  // console.log('table right -- ', tableRight);
  pageNum = Math.ceil(xData.length / 5);

  moSalaryIndustry.xData = xData;
  moSalaryIndustry.yData = yData;
  moSalaryIndustry.pageNum = pageNum;
  moSalaryIndustry.overview = overview;
  moSalaryIndustry.tableLeft = tableLeft;
  moSalaryIndustry.tableRight = tableRight;
  moSalaryIndustry.tableHead = uniq(years);
  moSalaryIndustry.labels = res.total_industry_data || [];
});

export default moSalaryIndustry;
export { initSalaryIndustry };
